import { useDispatch } from 'react-redux'
import { parseUser } from '../../models/User'
import * as api from '../api'
import { userActions } from '../store'
import useApiMutation from './useApiMutation'

export interface UpdateUserArguments {
  uuid: string
  firstname: string
  lastname: string
  position?: string | null
  username?: string
  email?: string | null
  role: string
  isActive: boolean
}

export default function useUpdateUser() {
  const dispatch = useDispatch()

  return useApiMutation({
    mutationFn: async (data: UpdateUserArguments) => {
      const res = await api.patch(`user/${encodeURIComponent(data.uuid)}`, {
        firstname: data.firstname,
        lastname: data.lastname,
        position: data.position !== undefined ? data.position || null : undefined,
        username: data.username || null,
        email: data.email || null,
        role: data.role,
        status: data.isActive ? 'active' : 'inactive',
      })

      const user = parseUser(res)
      if (user.error) {
        throw user.error
      }
      dispatch(userActions.add([user]))
    },
  })
}
